export default "__VITE_ASSET__BUYlBJFn__"